import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "../../services/shared.service";
import { MeetingDetailsPopupComponent } from "../../../shared/components/meeting-details-popup/meeting-details-popup.component";
import { MatDialog, MatPaginator, MatTableDataSource } from "@angular/material";
import { MentorService } from "src/app/mentor/services/mentors.service";
import { MeetingNotesWindowComponent } from "src/app/mentor/components/meeting-notes-window/meeting-notes-window.component";
import { MentorAuthService } from "src/app/mentor/services/mentor-auth.service";
import { ScheduleDialogComponent } from "src/app/mentor/components/schedule-dialog/schedule-dialog.component";
import { Location } from '@angular/common';
@Component({
  selector: "app-mentorship-details",
  templateUrl: "./mentorship-details.component.html",
  styleUrls: ["./mentorship-details.component.css"],
})
export class MentorshipDetailsComponent implements OnInit {
  scholarId: String = "";
  mentorId: String = "";
  mentorshipDetails: any = "";
  mentorScholar: any = [];
  loadData = true;
  noMeetings = false;
  displayedColumns = ["date", "type", "status",'lastUpdate','Notes','Docs', "Action"];
  displayedColumn = ["Date", "Action"];
  displayedCols = ["firstName", "lastName", "enrolledProgram", "scholarSince"];
  @ViewChild('paginator') paginator: MatPaginator;
  // @ViewChild('paginatorPageSize') paginatorPageSize: MatPaginator;

  feedbacks: any = [];
  model: any = {};
  mentorrId: any;
  modifiedData: any;
  meetings: any=[];
  mentorDetail: any = [];
  meetingDetails:any=[]
  noFeedback:boolean=true;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private sharedService: SharedService,
    private mentorService: MentorService,
    private matDialog: MatDialog,
    private mentorAuthService:MentorAuthService,
    private location: Location
  ) {
   
    this.scholarId = this.activatedRoute.snapshot.params["scholarId"];
    this.mentorrId = this.activatedRoute.snapshot.params["mentorId"];
  }

  ngOnInit() {
    if (this.mentorrId) {
      this.sharedService.getMentorScholarDetails(this.mentorrId).subscribe(
        (result: any) => {
          if (result) {
            this.mentorDetail = result;
            this.mentorScholar = new MatTableDataSource(result);
            this.mentorScholar.filterPredicate = function (
              data,
              filter: string
            ) {
              return (
                data.scholarId.firstName.toLowerCase().startsWith(filter) ||
                data.scholarId.lastName.toLowerCase().startsWith(filter) ||
                data.scholarId.email.toLowerCase().startsWith(filter)
              );
            };
            this.loadData = false;
            this.noMeetings = false;
          }
        },
        (error) => {},
        () => {
          this.getFeedbackByMentorIdAndScholarID();
        }
      );
    }
    if (this.router.url.includes("/co-ordinator/assign/mentorship/details")) {
      this.scholarId = this.activatedRoute.snapshot.params["scholarId"];
      this.sharedService.getMentorshipDetails(this.scholarId).subscribe(
        (result: any) => {
          if (result) {
            this.mentorshipDetails = result;
            this.mentorId = result.mentorId._id;
            this.meetings = new MatTableDataSource(result.meetings);
            this.meetings.paginator=this.paginator
            this.noMeetings = false;
            this.loadData = false;
          }
        },
        (error) => {},
        () => {
          this.mentorService
        .getFeedbackByMentorIdAndScholarID(this.mentorId, this.scholarId)
        .subscribe((res:any) => {
          if(res){
            this.noFeedback=false
            this.feedbacks = res;
          }else{
            this.noFeedback=true;
          }
          
        });
        }
      );
    }
    if (this.router.url.includes("/mentor/mentorship/details")) {
      this.sharedService.getMentorshipDetails(this.scholarId).subscribe(
        (result: any) => {
          if (result) {
            this.mentorshipDetails = result;
            this.mentorId = result.mentorId._id;
            this.meetings = new MatTableDataSource(result.meetings)
            this.meetings.paginator=this.paginator;
            this.noMeetings = false;
          } else {
            this.noMeetings = true;
          }
          this.loadData = false;
          this.getFeedbackByMentorIdAndScholarID();
        },
        (error) => {
          // Handle the error if needed
        }
      );
    }
  }
  showScholarDetails(details) {
    this.router.navigate(['co-ordinator/assign/mentorship/details/' +details.scholarId._id])
  }
  applyFilter(filterValue: string) {
    this.mentorScholar.filter = filterValue.trim().toLowerCase();
  }
  selectedFeedbackId() {
    this.model.feedbackId;
  }

  getFeedbackByMentorIdAndScholarID() {
    if (this.router.url.includes("/mentor/mentorship/details/")) {
      const mentorId = this.activatedRoute.snapshot.params["mentorId"];
      this.mentorService
        .getFeedbackByMentorIdAndScholarID(mentorId, this.scholarId)
        .subscribe((res) => {
          if(res){
            this.noFeedback=false
            this.feedbacks = res;
          }else{
            this.noFeedback=true;
          }
          
        });
    }
  }
  showDetails(details) {
    this.matDialog.open(MeetingDetailsPopupComponent, {
      width: "60%",
      height: "70%",
      data: {
        mentorNotes: details.mentorNotes,
        scholarNotes: details.scholarNotes,
        scholarComments: details.meetingComment,
      },
    });
  }
  addNotes(meetingDetails,documentId,scholarId,firstName,lastName){
    if(this.router.url.includes('/co-ordinator/assign/mentorship/details/')){
      this.router.navigate(['/co-ordinator/task/documents'],{queryParams:{meetingId:meetingDetails._id}})
    }
    else{
       this.router.navigate(['/mentor/task/documents'],{queryParams:{meetingId:meetingDetails._id}})
    }
    // // this.router.navigate(['/co-ordinator/task/documents'],{queryParams:{meetingId:meetingDetails._id}})
    // this.router.navigate(['/mentor/task/documents'],{queryParams:{meetingId:meetingDetails._id}})
  }
  goBack() {
    this.location.back();
  }
  getfeedbackById(id) {
    if (this.router.url.includes("/mentor/mentorship/details")) {
      this.router.navigate(["/mentor/view-feedback/" + id]);
    } else {
      this.router.navigate(["/co-ordinator/view-feedback/" + id]);
    }
  }
  editTask(taskDetails){
    const dialogRef = this.matDialog.open(ScheduleDialogComponent,{
      width:"800px",
      data:{taskDetails:{meetingId:taskDetails._id,date:taskDetails.date,time:taskDetails.time,type:taskDetails.meetingType,status:taskDetails.status,goal:taskDetails.goal,preferredTime:this.mentorshipDetails.scholarId.bestTimeToContact}}
    })
    dialogRef.afterClosed().subscribe(data =>{
      this.sharedService.getMentorshipDetails(this.scholarId).subscribe(
        (result: any) => {
          if (result) {
           
            this.mentorshipDetails = result;
            this.mentorId = result.mentorId._id;
            this.meetings = new MatTableDataSource(result.meetings)
            this.noMeetings = false;
          } else {
            this.noMeetings = true;
          }
          this.loadData = false;
          this.getFeedbackByMentorIdAndScholarID();
        },
        (error) => {
          // Handle the error if needed
        }
      );
    })
}
getLatestDate(notesLatestDate, documentsLatestDate, lastUpdatedDate) {
  const dates = [];

  if (notesLatestDate) {
    dates.push(new Date(notesLatestDate));
  }

  if (documentsLatestDate) {
    dates.push(new Date(documentsLatestDate));
  }

  if (lastUpdatedDate) {
    dates.push(new Date(lastUpdatedDate));
  }

  if (dates.length > 0) {
    const latestDate = new Date(Math.max.apply(null, dates));
    return latestDate.toISOString();
  }

  return null;
}
}
